import React from 'react';
import { useLensReturnPolicyStyles } from '../../../styles/molecules/lens-return-policy.styles';

export const LensReturnPolicyMolecule = () => {
  const classes = useLensReturnPolicyStyles();
  return (
    <div className={`p-5 lg:p-10 text-base mb-3 ${classes['return-policy']}`}>
      <h2 className="text-waldo-blue font-semibold text-base font-waldo-sans mb-1.5">
        Lens return policy
      </h2>
      <li className="text-waldo-blue leading-7">
        <span>Patients have 30 days to return from date of purchase</span>
      </li>
      <li className="text-waldo-blue leading-7">
        <span>Boxes need to be unopened / undamaged</span>
      </li>
      <li className="text-waldo-blue leading-7">
        <span>Full refund issued</span>
      </li>
      <li className="text-waldo-blue leading-7">
        <span>
          Patients need to email:{' '}
          <p className="font-normal inline-block">hello@hiwaldo.com</p> to
          initiate
        </span>
      </li>
    </div>
  );
};
